/** API service (using axios HTTP client) */
import axios from 'axios';

const api = axios.create({
    baseURL: process.env.VUE_APP_API_URL
});


export default {
    getTrades(success, failure) {
        api.get('trades')
            .then(function (response) {
                success(response.data);
            })
            .catch(function (error) {
                failure(error.toString());
            })
    },

    getVehicles(id, success, failure) {
        api.get('loads/' + id + '/vehicle_types')
            .then(function (response) {
                success(response.data);
            })
            .catch(function (error) {
                failure(error.toString());
            })
    }
}